import React from 'react';
import { FaSearch, FaTh, FaList } from 'react-icons/fa';

const ItemSearchBar = ({ 
  searchQuery, 
  onSearchChange, 
  filters, 
  onFilterChange, 
  onViewModeChange, 
  viewMode 
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-lg select-none">
      <div className="flex flex-col md:flex-row gap-4">
        {/* Search Input */}
        <div className="flex-1 relative">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search items..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 
              dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-teal-500 
              focus:border-transparent transition-colors"
          />
        </div>

        {/* Stock Filter */}
        <select
          value={filters.stock || ''}
          onChange={(e) => onFilterChange({ ...filters, stock: e.target.value })}
          className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 
            dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-teal-500 
            focus:border-transparent transition-colors"
        >
          <option value="">All Stock</option>
          <option value="in-stock">In Stock</option>
          <option value="low-stock">Low Stock (&lt;10)</option>
          <option value="out-of-stock">Out of Stock</option>
        </select>

        {/* View Toggle */}
        <div className="flex rounded-lg border w-max border-gray-300 dark:border-gray-600 overflow-hidden">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`px-4 py-2 transition-colors ${
              viewMode === 'grid'
                ? 'bg-teal-500 text-white'
                : 'bg-transparent text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
          >
            <FaTh />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`px-4 py-2 transition-colors ${
              viewMode === 'list'
                ? 'bg-teal-500 text-white'
                : 'bg-transparent text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
          >
            <FaList />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ItemSearchBar;

